var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 81,
    viewBox: "0 0 81 81",
    width: 81,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Highlight") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-840.000000, -8207.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(880.527648, 8247.702803) rotate(43.000000) translate(-880.527648, -8247.702803) translate(852.000000, 8220.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.055296919,0.0822112063 L57.0552969,0.0822112063 L57.0552969,54.0822112 L0.055296919,54.0822112 L0.055296919,0.0822112063 Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33213782,48.422302 C1.17652692,48.2782941 0.103620836,49.0819186 0.0210771982,50.2141182 C-0.144010077,51.3471455 0.681909998,52.3833384 1.75497723,52.5273462 C6.95522649,53.1886237 12.3200783,53.8962444 17.3552401,55.3272189 C18.4283073,55.6375807 19.5844019,54.9986572 19.9145765,53.8995629 C20.244751,52.8012961 19.5842407,51.6566832 18.5111734,51.3454939 C13.2283806,49.859068 7.69747419,49.1092359 2.33213782,48.422302 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89445857,9.73623305 C6.11638842,8.99812371 4.73315258,8.95858055 3.86863016,9.64762903 C3.00410774,10.3374097 2.9179932,11.4972932 3.78251562,12.2354025 C12.5141924,20.161291 22.5426523,26.889218 31.4472334,34.6086113 C32.3117558,35.3291466 33.694654,35.3393972 34.5591764,34.6305779 C35.3372465,33.9224909 35.4236988,32.7626119 34.5591764,32.0420766 C25.6545953,24.3453832 15.6261353,17.6394217 6.89445857,9.73623305 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8810857,15.2471318 C51.8810857,16.262882 52.8975426,17.0471768 54.0828303,16.9977899 C55.2681179,16.9476657 56.1142559,16.0830285 56.1142559,15.0665411 C55.8602657,10.6246608 55.6067716,6.18351421 55.3527814,1.74237095 C55.268118,0.726620672 54.2519917,-0.0525147107 53.0667041,0.0027692317 C51.9660798,0.0580531741 51.0349477,0.927856588 51.1196112,1.94286971 C51.3736014,6.37737868 51.6270955,10.8118854 51.8810857,15.2471318 Z",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/Highlight.a8e11b5d64dfa435a6b407ec17496f50.svg";
export { ForwardRef as ReactComponent };